import AOS from 'aos';
import vars from '../globals';

AOS.init({
	disable: innerWidth <= 1024,
	offset: 60,
	once: true,
});

export const refreshAOS = () => {
	AOS.refresh();
};

const $button = $('.product-play-button');
const $contentBlock = $('.product-text--1 .product-text__container');
const $sign = $('.site-background__figure--7');

export const checkProductHeroAos = () => {
	if (vars.$window.height() > $('.product-text--1').offset().top) {
		$button.attr('data-aos-delay', '1500');
		$contentBlock.attr('data-aos-delay', '1500');
		$sign.attr('data-aos-delay', '1500');
	}
};

export const cleareProductHeroAos = () => {
	$button.removeAttr('data-aos-delay');
	$contentBlock.removeAttr('data-aos-delay');
	$sign.removeAttr('data-aos-delay');
};
